module.exports = __webpack_public_path__ + "img/icon-map-play.c9be40e4.svg";